export default "__VITE_ASSET__C3Oo0N15__"